var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group-append" }, [
    _c(
      "div",
      {
        staticClass: "border-0 btn btn-primary bg-white text-accent-black px-0",
        attrs: {
          "aria-haspopup": "true",
          "aria-expanded": "true",
          type: "button",
          "data-toggle": "dropdown"
        }
      },
      [
        _vm._v("\n    " + _vm._s(_vm.checkRole(_vm.user.role)) + "\n    "),
        _c("span", {
          staticClass:
            "png-icon bg-light position-relative png-icon-icons-glyph--k-chevron-down mb-1 bg-transparent mr-0"
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rounded dropdown-menu dropdown-menu-right bg-white" },
      [
        _vm._l(_vm.roles, function(role, index) {
          return _c(
            "a",
            {
              key: index,
              staticClass: "dropdown-item font-16",
              attrs: { href: "", role: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.userRoleChangeHandler({
                    emailFromUsersList: _vm.user.email,
                    newRole: role.role
                  })
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "item-texts d-flex justify-content-center",
                  staticStyle: { "flex-direction": "column" }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "role-label role-label-font-wt role-label-font-wt"
                    },
                    [_vm._v("\n          " + _vm._s(role.label) + "\n        ")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "role-description" }, [
                    _vm._v(_vm._s(role.description))
                  ])
                ]
              )
            ]
          )
        }),
        _vm._v(" "),
        _vm.isRemoveAccess
          ? _c(
              "a",
              {
                staticClass: "remove-btn dropdown-item font-16 text-danger",
                attrs: { href: "", role: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.userDeleteFromRoleListHandler(_vm.user.email)
                  }
                }
              },
              [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _vm.$resourceString[
                        "myProject.shareTray.Title.Dropdown.RemoveAccess"
                      ]
                    ) +
                    "\n    "
                )
              ]
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }